var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 50,
    height: 49.4472,
    viewBox: "0 0 50 49.4472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.0625 0H10.9375C4.90625 0 0 4.852 0 10.8166V38.6306C0 44.5952 4.90625 49.4472 10.9375 49.4472H39.0625C45.0938 49.4472 50 44.5952 50 38.6306V10.8166C50 4.852 45.0938 0 39.0625 0ZM46.875 38.6306C46.875 42.8908 43.3703 46.3567 39.0625 46.3567H10.9375C6.62969 46.3567 3.125 42.8908 3.125 38.6306V10.8166C3.125 6.55638 6.62969 3.09045 10.9375 3.09045H39.0625C43.3703 3.09045 46.875 6.55638 46.875 10.8166V38.6306Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.72,
    r: 11.2,
    stroke: "white",
    strokeWidth: 3.125
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6,
    cy: 11.1,
    r: 2.6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.400c67d52cdb3433aaec924d3708a884.svg";
export { ForwardRef as ReactComponent };